import styled from 'styled-components'
import { customTheme } from '../styles/theme'

export const CameraContainer = styled.div`
  display: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 999;

  &.active {
    display: block;
  }

  &.user {
    video {
      transform: scaleX(-1);
    }
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999999;
    display: none;
  }

  video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ModalError = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
`

export const BgModal = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background: #0000008c;
  z-index: 1;
`

export const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);

  width: 600px;
  max-width: 90%;
  padding: 30px;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: #fdfdfd73;
  border: 1.84534px solid rgba(188, 188, 188, 0.74);
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 33px;

  h2 {
    margin-bottom: 20px;
    text-align: center;
    font-size: 1.5rem;
  }

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #5aff5a;
    border: 2px solid #606060;
    opacity: 1;
    box-sizing: border-box;
    box-shadow: 0px 4px 16px rgb(0 0 0 / 50%);
    border-radius: 10vw;
    font-family: Poppins;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.2;
    color: #000000;
    cursor: pointer;
    padding: 15px;
  }

  label {
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 2px;
    color: #fff;
  }

  form {
    width: 60%;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      width: 90%;
    }
  }

  input {
    height: 38px;
    border-radius: 20px;
    border: none;
    background-color: #fff;
    padding-left: 15px;
    font-size: 11px;
    margin-bottom: 10px;
    width: 100%;
  }

  .title {
    display: flex;
    color: white;
    margin-bottom: 10px;

    > * {
      padding: 5px;
    }
  }
  
  a {
    text-decoration: none;
    width: 100%;
  }
`

export const CloseModal = styled.div`
  position: absolute;
  transform: rotate(45deg);
  background: none;
  border: none;
  right: 15px;
  top: 0px;
  color: white;
  font-size: 44px;
  font-weight: bold;
  cursor: pointer;
  outline: none;
`

export const PickPhotoWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 99999;
  aspect-ratio: 1/1;

`

export const PickPhoto = styled.label`
  background: none;
  border: none;
  background: #000;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;

  img {
    width: 30px;
  }
`

export const ChangeCamera = styled.button`
  position: absolute;
  bottom: 40px;
  left: 15px;
  z-index: 99999;
  background: none;
  border: none;
  background-color: #fff;
  border: 2px solid #000;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media (min-width: ${customTheme.breakpoints[2]}) {
    display: none;
  }
`

export const CloseCamera = styled.label`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 99999;
  background: none;
  border: none;
  background: #000;
  width: 60px;
  height: 60px;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
  cursor: pointer;
`

export const RelativeBox = styled.div`
  position: relative;
`

export const TakePhoto = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;

  > button {
    background: none;
    border: none;
    background: #fff;
    border: 2px solid #000;
    width: 100px;
    height: 50px;
    border-radius: 25px;
  }
`

export const InfoBalloon = styled.div<any>`
  position: absolute;
  background: #4F4F4F;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  display: flex;
  padding: 5px 15px 5px 5px;
  border-radius: 5px;
  width: 110%;

  &:before {
    content: '';
    border: 10px solid transparent;
    border-top-color: #4F4F4F;
    border-bottom-width: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 15px;
    width: 15px;
    top: 93%;
  }

  &.left-side {
    top: 50%;
    transform: translateY(-50%);
    left: 120%;
    width: 130px;
    height: 26px;

    &:before {
      content: '';
      border: 10px solid transparent;
      border-right-color: #4F4F4F;
      border-left-width: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 15px;
      width: 15px;
      left: -13px;
    }
  }

  span {
    color: #fff;
    font-size: 12px;
  }

  button {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    margin: 0;
    padding: 0;
    border: none;
    color: #fff;
    font-size: 12px;
    margin-top: 2px;
  }
`
